import type { ZodSchema } from 'zod';
import { validateSchemaAsync } from './validateSchemaAsync';

export const validateApiResponse = <S extends ZodSchema>(schema: S) => validateSchemaAsync(schema);
